import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaLinkedin, FaArrowRight, FaApple } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const scrollToTop = () => window.scrollTo(0, 0);
  const year = new Date().getFullYear();

  return (
    <footer className="fh-footer fh-footer-grad">
      <div className="fh-footer-orb fh-footer-orb-a" />
      <div className="fh-footer-orb fh-footer-orb-b" />

      <div className="fh-container fh-footer-cta">
        <div className="fh-footer-cta-inner">
          <div className="fh-pill fh-footer-pill">
            <span className="fh-pill-dot" style={{ background: 'var(--gold-light)' }} />
            Open for partners
          </div>

          <h2 className="fh-footer-cta-title">
            Let&apos;s build the next chapter of <span className="fh-gradient-text-warm">halal commerce</span>.
          </h2>
          <p className="fh-footer-cta-sub">
            Whether you run a restaurant, a catering business, or a venture fund, we&apos;d love to talk.
          </p>
          <div className="fh-footer-cta-buttons">
            <Link to="/pricing" className="fh-btn fh-btn-lg fh-footer-btn-primary">
              Partner with us <FaArrowRight />
            </Link>
            <a
              href="https://apps.apple.com/us/app/halwaa/id6738673791"
              target="_blank" rel="noopener noreferrer"
              className="fh-btn fh-btn-lg fh-footer-btn-ghost"
            >
              <FaApple /> Get halwaa
            </a>
          </div>
        </div>
      </div>

      <div className="fh-footer-divider" />

      <div className="fh-container fh-footer-grid">
        <div className="fh-footer-brand">
          <div className="fh-footer-logo">
            <span className="fh-footer-logo-mark">f</span>
            <span>findhalal<span className="fh-footer-logo-inc">Inc.</span></span>
          </div>
          <p className="fh-footer-mission">
            Building the digital infrastructure for the halal economy. Headquartered in Atlanta, serving owners and diners across the US.
          </p>
        </div>

        <div className="fh-footer-col">
          <h4>Company</h4>
          <Link to="/about" className="fh-footer-link" onClick={scrollToTop}>About</Link>
          <Link to="/pricing" className="fh-footer-link" onClick={scrollToTop}>Partner with us</Link>
          <Link to="/contact" className="fh-footer-link" onClick={scrollToTop}>Contact</Link>
          <a href="mailto:hasan@findhalal.us?subject=findhalal%20Inc%20Investor%20Inquiry" className="fh-footer-link">Investors</a>
        </div>

        <div className="fh-footer-col">
          <h4>Product</h4>
          <a href="https://apps.apple.com/us/app/halwaa/id6738673791" className="fh-footer-link" target="_blank" rel="noopener noreferrer">Download halwaa</a>
          <a href="https://www.halwaa.app/" className="fh-footer-link" target="_blank" rel="noopener noreferrer">halwaa.app</a>
          <Link to="/help" className="fh-footer-link" onClick={scrollToTop}>Help Center</Link>
        </div>

        <div className="fh-footer-col">
          <h4>Legal</h4>
          <Link to="/terms-of-service" className="fh-footer-link" onClick={scrollToTop}>Terms of Service</Link>
          <Link to="/terms-of-service" className="fh-footer-link" onClick={scrollToTop}>Privacy Policy</Link>
        </div>
      </div>

      <div className="fh-container fh-footer-bottom">
        <div className="fh-footer-copyright">
          © {year} findhalal Inc. · Built in Atlanta with intention.
        </div>
        <div className="fh-footer-socials">
          <a href="https://www.instagram.com/halwaa.app" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
          <a href="https://www.linkedin.com/company/halwaa" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedin /></a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
